import { createContext } from 'react'

const CustomCookieBoxContext = createContext()

export default CustomCookieBoxContext
